function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, ".st0{fill-rule:evenodd;clip-rule:evenodd;}");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M59.3974 44C38.1912 55.7544 25.9642 55.7886 3.70072 44C0.168991 61.6313 0.0311871 71.701 3.70072 90.0364C26.0215 94.0462 38.1997 93.9291 59.3974 90.0364C63.0055 71.9364 62.7267 61.8647 59.3974 44Z"
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 32,
  cy: 23,
  r: 22.5
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M29.338 62.1224L23 52H41L34.662 62.1224V83L32 87L29.338 83V62.1224Z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M29.338 62.1224L23 52H41L34.662 62.1224M29.338 62.1224H34.662M29.338 62.1224V83M34.662 62.1224V83M29.338 83H34.662M29.338 83L32 87L34.662 83"
});

var SvgProfessional = function SvgProfessional(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 94,
    viewBox: "0 0 103 94",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgProfessional, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Professional.1fb57aaa.svg";
export { ForwardRef as ReactComponent };